import React, { JSX } from 'react';

export type PersonalAccountProps = {
    displayName: string;
    active: boolean;
    track?: (name: string, variable?: number) => void;
};

export type AccountProps = {
    title: string;
    link: string;
    onClick: () => void;
} & PersonalAccountProps;

function Account(props: AccountProps): JSX.Element {
    const { link, active, title, displayName, onClick } = props;

    return (
        <a
            onClick={onClick}
            href={link}
            className={'topbar__account-list__item'}
        >
            <div
                className={`topbar__account-list__item__content p-8
                        ${
                            active
                                ? ' topbar__account-list__item__content__active'
                                : ''
                        }`}
            >
                <div className="topbar__account-list__title">{title}</div>
                <div className="topbar__account-list__header">
                    {displayName}
                </div>
            </div>
        </a>
    );
}

export function PersonalAccount(props: PersonalAccountProps): JSX.Element {
    return (
        <Account
            title={'Din personlige konto'}
            link={'/my-page'}
            onClick={function (): void {
                props.track?.('account-menu-personal-click');
            }}
            {...props}
        />
    );
}

function marketToTitle(market: string): string {
    switch (market) {
        case 'JOB':
            return 'FINN jobb';
        case 'REAL_ESTATE':
            return 'FINN eiendom';
        case 'MOTOR':
            return 'FINN motor';
        case 'BAP':
            return 'FINN torget';
        default:
            return 'Admin';
    }
}

export type OrganisationProps = {
    orgId: number;
    market: string;
} & PersonalAccountProps;

export function BusinessAccount(props: OrganisationProps): JSX.Element {
    return (
        <Account
            title={marketToTitle(props.market)}
            link={`/bedrift?orgId=${props.orgId}`}
            onClick={function (): void {
                props.track?.('account-menu-org-click', props.orgId);
            }}
            {...props}
        />
    );
}
